import { PRODUCT_APPLICATION_IDS as _PRODUCT_APPLICATION_IDS } from '@domain/data/Constants'

export const PRODUCT_GRID_ITEM_ATTRIBUTES = [
	'finish',
	'ledColourTemp',
	'control',
	'installation',
	'lumensLed',
	'watts',
	'pendantHeight'
]
export const PRODUCT_GRID_CREATION_ITEM_ATTRIBUTES = [
	'finish',
	'ledColourTemp',
	'control',
	'installation',
	'totalLumensLed',
	'totalWatts',
	'pendantHeight'
]

export const PROJECT_BUDGET_REQUEST = 'project_budget'

export const PRODUCT_TYPE_REGULAR = 'REGULAR'
export const PRODUCT_TYPE_CREATION = 'CREATION'
export const COMPOSING_PENDANTS = 'COMPOSING_PENDANTS'

export const PRODUCT_CATEGORIES = {
	REGULAR: 1,
	SPECIFIC_PLAYER: 2,
	MODULAR: 3,
	LG2: 4,
	VIRTUAL: 5,
	TOOLKIT: 6,
	COMPOSING_PENDANTS: 7
}

export const PRICE_TYPES = {
	net: {
		unit: 'unitNet',
		total: 'totalNet'
	},
	gross: {
		unit: 'unitGross',
		total: 'totalGross'
	}
}

export const PRODUCT_APPLICATION_IDS = _PRODUCT_APPLICATION_IDS

export const CREA_CONFIGURATOR_MODES = ['create', 'edit', 'validate']
export const STICKS_DRAWING_CONFIGURATOR_MODES = ['CREATE', 'EDIT', 'VALIDATE', 'EXPORT']
export const STICKS_NODRAWING_CONFIGURATOR_MODES = ['CREATE', 'EDIT', 'VALIDATE']
export const PLUSMINUS_DRAWING_CONFIGURATOR_MODES = ['CREATE', 'EDIT', 'VALIDATE', 'EXPORT', 'VIEW']
export const PLUSMINUS_NODRAWING_CONFIGURATOR_MODES = ['CREATE', 'EDIT', 'VALIDATE', 'VIEW']

export const DISABLED_DOWNLOAD_TYPES_ON_CREATION_PRODUCTS = ['energy']
export const VALIDATED_CREATION_PRODUCT = ['installation']

export const PRODUCT_DOWNLOAD_TYPES = [
	{
		type: 'all',
		checked: false
	},
	{
		type: 'info',
		docType: 'specSheet',
		checked: false
	},
	{
		type: 'techSheetComposition',
		docType: 'techSheetComposition',
		checked: false
	},
	{
		type: 'installation',
		docType: 'manual',
		checked: false
	},
	{
		type: 'energy',
		docType: 'energyLabel',
		checked: false
	},
	{
		type: 'model3d',
		docType: '2D_3D',
		checked: false
	},
	{
		type: 'imagehd',
		docType: 'imagehd',
		subType: ['imagehdProduct', 'imagehdAmbient'],
		checked: false
	},
	{
		type: 'photometry',
		docType: 'photometry',
		checked: false
	}
]

export const COMPOSITION_ATTRIBUTE_CONFIG = [
	{
		source: 'lights',
		attributePath: 'color',
		targetKey: 'finish'
	},
	{
		source: 'lights',
		attributePath: 'temperature',
		targetKey: 'ledColourTemp'
	},
	{
		source: 'lights',
		attributePath: 'pendantHeight',
		targetKey: 'pendantHeight'
	},
	{
		source: 'accessories',
		attributePath: 'installation',
		targetKey: 'installation'
	},
	{
		source: 'accessories',
		attributePath: 'control',
		targetKey: 'control',
		takeFirst: true
	}
]

export const ERROR_DOWNLOAD_FILE = 3
